<template>
	<div 
		class="modal fade custom-modal auth-modal" 
		id="login-modal"
		role="dialog" 
		aria-labelledby="login-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="closeModal">
                        <i class="fa fa-close"></i>
                    </button>
                </div>

            	<div class="modal-body">
            		<div class="row">
            			<div class="col-xs-12 col-sm-12 col-md-12">
            				<div class="auth-logo">
            					<img src="../../assets/logowithname.png">
            				</div>

            				<p class="text-center small-margin-top">Hurry! Your food awaits!</p>
            			</div>

            			<div class="col-xs-12 col-sm-12 col-md-12">
				            <form role="form" @submit.prevent="loginUser">
								<!-- Email field -->
								<div class="form-group" :class="{ 'has-error': errors.has('email') }">
		                            <label for="email">Email</label>

									<input 
										type="text" 
										id="email" 
										name="email" 
										v-model="user.email" 
										class="form-control" 
										v-validate="rules.email"
										placeholder="user@ezifood.com"
										autocomplete="false">

									<error-label :show="errors.has('email')">{{ errors.first('email') }}</error-label>
		                        </div>

								<!-- Password field -->
								<div class="form-group" :class="{ 'has-error': errors.has('password') }">
		                            <label for="password">Password</label>

									<input 
										type="password" 
										id="password" 
										name="password" 
										v-model="user.password" 
										class="form-control" 
										v-validate="rules.password"
										placeholder="******"
										autocomplete="false">
									
									<error-label :show="errors.has('password')">{{ errors.first('password') }}</error-label>
		                        </div>

								<div class="footer">
								    <div class="row">
								        <div class="col-md-12">
								            <button 
				                            	type="submit"
				                            	:disabled="!allowLogin" 
				                            	class="btn btn-warning btn-fill small-margin-top btn-block">Log In</button>
										        </div>
								    </div>
		                        </div>			         					
							</form>
                            <div class="row">
						        <div class="col-md-12">
						            <button 
						                @click.prevent="initReset"
		                            	class="btn btn-info btn-fill small-margin-top btn-block">Forgot Your Password ?</button>
						        </div>
						    </div>
								    
							<p class="text-center small-margin-top">Don't have an account? <a @click.prevent="initSignup" class="text-warning pointer">Sign Up</a></p>		
						</div>
					</div>		
				</div>
            </div>
        </div>
    </div>
</template>

<script>
	import { mapActions } from 'vuex';

	export default {
		props: ['isOpenModal'],

		data() {
			return {
				rules: {
					email: 'required|email',
					password: 'required|min:6'
				},

				user: {
					email: '',
					password: ''
				},
			}
		},

		computed: {
			/**
			 * Allow the login button.
			 * Make sure all fields have passed the validations.
			 * 
			 * @return {Boolean}
			 */
			allowLogin() {
				if (!this.user.email || !this.user.password || this.errors.any()) {
					return false;
				}

				return true;
			}
		},

		watch: {
			/**
			 * Watch for changes in the isOpenModal variable.
			 * Open when true else close
			 * 
			 * @param  {Boolean}  value 
			 * @return {Boolean}       
			 */
			isOpenModal(value) {	
				if (value) {
					this.openModal();
				} else {
					this.closeModal();
				}
			}
		},

		methods: {
			...mapActions({
				authenticate: 'User/authenticate', 
                showLoginModal: 'User/setShowLogin',
                showSignupModal: 'User/setShowSignup',
                showResetModal: 'User/setShowReset'
			}),

			/**
			 * Open login modal. Reset form first.
			 * 
			 * @return null
			 */
			openModal() {
				$('#login-modal').appendTo('body').modal({
					backdrop: 'static'
				});

				this.$nextTick(() => {
					this.errors.clear();
				});
			},

			/**
			 * Close login modal then resets form.
			 * 
			 * @return null
			 */
			closeModal() {
				$('#login-modal').modal('hide');
				this.resetForm();
				this.showLoginModal(false);
			},

			/**
			 * Resets login form and also clear form errors.
			 * 
			 * @return null
			 */
			resetForm() {
				this.user.email = '';
				this.user.password = '';
				this.errors.clear();
			},

			/**
			 * Logs in specified user with the provided credentials.
			 * Before that it validate the credentail fields
			 *
			 * @return null
			 */
			loginUser() {
				this.showLoader();
				this.$validator.validateAll()
					.then(() => this.authenticate(this.user))
					.then((response) => {
						this.closeModal();

						this.notify({
							message: 'You have successfully logged in.',
							type: 'success'
						});
					})
					.catch((errors) => {				
						this.buildErrorMessages(errors)
							.then((data) => {
								this.notify({
									message: data,
									type: 'danger'
								});
							});
					})
					.then(() => this.hideLoader());
			},

			/**
			 * Initialize signup for the user.
			 * Close the login modal and show the signup modal
			 * 
			 * @return null
			 */
			initSignup() {
				this.closeModal();
				this.showSignupModal(true);
			},

			/**
			 * Initialize password reset for the user.
			 * Close the login modal and show the rest modal
			 *
			 * @return null
			 */
			initReset() {
				this.closeModal();
				this.showResetModal(true);
			}
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Login.vue?3966623e